import { render, staticRenderFns } from "./MasterCrudPage.vue?vue&type=template&id=65eb9363&scoped=true"
import script from "./MasterCrudPage.vue?vue&type=script&lang=js"
export * from "./MasterCrudPage.vue?vue&type=script&lang=js"
import style0 from "./searchableSelectSm.css?vue&type=style&index=0&id=65eb9363&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.44.2__css-load_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb9363",
  null
  
)

export default component.exports